import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53')
];

export const server_loads = [];

export const dictionary = {
		"/(app)/(prode)": [13,[2]],
		"/(app)/admin/chat/[id]": [28,[2,5]],
		"/(app)/admin/execution/[id]": [29,[2,5]],
		"/(app)/admin/teams": [30,[2,5]],
		"/(app)/admin/teams/[team_id]": [31,[2,5]],
		"/(app)/admin/users": [32,[2,5]],
		"/(age_verification)/age-verification": [10],
		"/(app)/ai-agent-manager": [33,[2,6]],
		"/(app)/ai-agent-manager/ai-agents": [34,[2,6,7]],
		"/(app)/ai-agent-manager/ai-agents/create": [35,[2,6,7]],
		"/(app)/ai-agent-manager/ai-agents/edit": [36,[2,6,7]],
		"/(app)/(prode)/analytics": [14,[2]],
		"/(app)/(prode)/analytics/[team_id]": [15,[2]],
		"/(app)/api-provider-selection": [37,[2]],
		"/auth": [51],
		"/(app)/billing": [38,[2]],
		"/(app)/(mobile_view)/chats": [11,[2,3]],
		"/(app)/c": [39,[2]],
		"/(app)/c/codebase": [42,[2]],
		"/(app)/c/codebase/[id]": [43,[2]],
		"/(app)/c/[id]": [40,[2]],
		"/(app)/c/[id]/s/[shareId]": [41,[8]],
		"/(app)/(prode)/documentation": [16,[2]],
		"/error": [52],
		"/(app)/(prode)/integrations": [17,[2]],
		"/(app)/(prode)/integrations/azure-devops/connect": [20,[2]],
		"/(app)/(prode)/integrations/azure-devops/manage-organizations": [21,[2]],
		"/(app)/(prode)/integrations/gitlab/connect-pat": [22,[2]],
		"/(app)/(prode)/integrations/gitlab/manage-groups": [23,[2]],
		"/(app)/(prode)/integrations/[integrationType]/manage-organizations": [18,[2,4]],
		"/(app)/(prode)/integrations/[integrationType]/manage-workspaces": [19,[2,4]],
		"/(app)/manage-team": [44,[2]],
		"/(app)/(prode)/mcp-server": [24,[2]],
		"/(app)/(mobile_view)/my-profile": [12,[2,3]],
		"/(app)/oauth/authorize": [45,[2]],
		"/(onboarding)/onboarding/[step]": [49,[9]],
		"/(payment)/payments/[status]": [50],
		"/(app)/(prode)/projects": [25,[2]],
		"/(app)/(prode)/projects/[project_id]": [26,[2]],
		"/(app)/(prode)/repositories": [27,[2]],
		"/(app)/settings": [46,[2]],
		"/(app)/teams/[teamId]/edit": [47,[2]],
		"/(app)/teams/[team_id]/[...path]": [48,[2]],
		"/verification-link-error": [53]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';